import React from 'react'
import { Moneda } from '../../../../../../Helpers/Moneda';
import { TextField } from '@mui/material';
import { ValTextAndNumber } from '../../../../../../Validators/ValTextAndNumber';
import { ValOnlyNumber } from '../../../../../../Validators/ValOnlyNumber';
import { FlipToBackSharp } from '@mui/icons-material';

export const TablaAmortizacionesModal = ({ tablaAmortizacion, setTablaAmortizacion }) => {
    // console.log(tablaAmortizacion)

    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setTablaAmortizacion({
            ...tablaAmortizacion,
            [prop]: sinComas,
            ["b" + prop]: false,
            ["m" + prop]: "",
        });
    };
    return (
        <div className='tabla-amortizaciones-main-container-screen'>
            <div className='tabla-amortizaciones-container-inputs'>
                <div className='tabla-amortizaciones-input-plazos'>
                    <TextField
                        fullWidth
                        size="small"
                        label="Inicio de Credito"
                        variant="outlined"
                        className="input-fecha-inicio-credito"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        sx={{
                            backgroundColor: '#f6f8f2', // Suave contraste con #dce1d1
                            borderRadius: '5px',
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#8ba57a',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#6f8a5b',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#3d5236',
                                    boxShadow: '0 0 0 2px rgba(61, 82, 54, 0.1)'
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#4f6043', // Etiqueta del input
                            },
                            '& .MuiInputBase-input': {
                                color: '#2e3a2a', // Texto del input
                            },
                        }}
                        onChange={({ target }) => {
                            setTablaAmortizacion({ ...tablaAmortizacion, inicio: target.value });
                        }}
                        value={tablaAmortizacion.inicio}
                    />

                    <TextField
                        className="input-plazo-meses"
                        size="small"
                        label="Plazo (meses)"
                        variant="outlined"
                        type="text"
                        sx={{
                            backgroundColor: '#f6f8f2', // Suave contraste con #dce1d1
                            borderRadius: '5px',
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#8ba57a',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#6f8a5b',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#3d5236',
                                    boxShadow: '0 0 0 2px rgba(61, 82, 54, 0.1)'
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#4f6043', // Etiqueta del input
                            },
                            '& .MuiInputBase-input': {
                                color: '#2e3a2a', // Texto del input
                            },
                        }}
                        error={tablaAmortizacion.bplazo}
                        onChange={({ target }) => {
                            setTablaAmortizacion({ ...tablaAmortizacion, plazo: target.value });
                        }}
                        value={tablaAmortizacion.plazo}
                        inputProps={{
                            style: { textAlign: "right" },
                        }}
                    />
                </div>
                <div className='tabla-amortizaciones-inputs-numeros'>
                    <TextField
                        className="input-importe-credito"
                        size="small"
                        id="financiamineto"
                        label="Importe a Financiar"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        type="text"
                        error={tablaAmortizacion.bimporte}
                        onChange={({ target }) => {
                            ValTextAndNumber("importe", target.value, onChange, true, 10);
                        }}
                        onKeyUp={(input) => Moneda(input.target)}
                        sx={{
                            backgroundColor: '#f6f8f2', // Suave contraste con #dce1d1
                            borderRadius: '5px',
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#8ba57a',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#6f8a5b',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#3d5236',
                                    boxShadow: '0 0 0 2px rgba(61, 82, 54, 0.1)'
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#4f6043', // Etiqueta del input
                            },
                            '& .MuiInputBase-input': {
                                color: '#2e3a2a', // Texto del input
                            },
                        }}
                        inputProps={{
                            style: { textAlign: "right" },
                        }}
                    />

                    <TextField
                        className="input-tasa-credito"
                        size="small"
                        label="Tasa %"
                        variant="outlined"
                        type="number"
                        error={tablaAmortizacion.btasa}
                        // onKeyUp={(input) => Moneda(input.target)}
                        onChange={({ target }) => {
                            ValOnlyNumber("tasa", target.value, onChange, true, 10);
                        }}
                        value={tablaAmortizacion.tasa}
                        sx={{
                            backgroundColor: '#f6f8f2', // Suave contraste con #dce1d1
                            borderRadius: '5px',
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#8ba57a',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#6f8a5b',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#3d5236',
                                    boxShadow: '0 0 0 2px rgba(61, 82, 54, 0.1)'
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#4f6043', // Etiqueta del input
                            },
                            '& .MuiInputBase-input': {
                                color: '#2e3a2a', // Texto del input
                            },
                        }}
                        inputProps={{
                            style: { textAlign: "right" },
                        }}
                    />
                </div>
            </div>

        </div>
    )
}
